<div class="metric-settings-tooltip">
  <div class="tooltip-name">
    {{ name }}
  </div>
  <div class="tooltip-desc">
    Defined as {{ getDescWithoutCapitalize(desc) }}
  </div>
</div>
